import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { tap } from 'rxjs/operators';
import { DemoDialogComponent } from './demo-dialog/demo-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DemoService {
  private dialogOpen: boolean;

  constructor(private dialog: MatDialog) {}

  public openDialog(): void {
    if (!this.dialogOpen) {
      this.dialogOpen = true;
      this.dialog
        .open(DemoDialogComponent, {
          closeOnNavigation: true,
          disableClose: true,
          maxWidth: 360,
        })
        .afterClosed()
        .pipe(tap(() => (this.dialogOpen = false)))
        .subscribe();
    }
  }
}
